<template>
  <vue-seamless-scroll
    :data="projectData"
    class="project-info-content"
    :class-option="classOption"
    v-if="projectData.length > 0"
  >
    <!-- <div :class="['project-info-content', autoScroll ? 'scroll-content' : '']"> -->
    <div
      class="project-info-item"
      v-for="(item, index) in projectData"
      :key="index"
    >
      <div class="project-name">{{ item.name }}</div>
      <div class="project-info-detail">
        <div
          class="project-info-detail-item"
          v-for="(subItem, subIndex) in item.childer"
          :key="subIndex"
          :style="{ background: getBackColor(subItem) }"
        >
          <div
            class="project-info-detail-item-percent-back"
            :style="{
              width: subItem.progress,
              background: getProgressColor(subItem),
            }"
          ></div>
          <div v-show="subItem.isFinish === true" class="project-finish-icon">
            <i class="el-icon-check" style="color: #fff; font-size: 0.8rem"></i>
          </div>
          <div class="project-info-detail-item-content">
            {{ subItem.name }}
          </div>
          <div class="project-info-detail-item-percent">
            {{
              subItem.isStart && subItem.isFinish === false
                ? subItem.progress
                : ""
            }}
          </div>
        </div>
        <!-- <div class="project-info-detail-item" style="background: #976a3466">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 60%; background: #976a34"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent">60%</div>
        </div>
        <div class="project-info-detail-item" style="background: #976a3466">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 60%; background: #976a34"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent">0%</div>
        </div>
        <div class="project-info-detail-item" style="background: #253e67">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 60%; background: #253e67"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent"></div>
        </div>
        <div class="project-info-detail-item" style="background: #0e456f">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 100%; background: #1b82a1"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent"></div>
        </div>
        <div class="project-info-detail-item" style="background: #0e456f">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 100%; background: #1b82a1"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent"></div>
        </div> -->
      </div>
    </div>
    <!-- <div class="project-info-item">
      <div class="project-name">基于abc的项目</div>
      <div class="project-info-detail">
        <div class="project-info-detail-item" style="background: #0e456f">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 60%; background: #1b82a1"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent">60%</div>
        </div>
        <div class="project-info-detail-item" style="background: #976A3466">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 60%; background: #976A34"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent">60%</div>
        </div>
        <div class="project-info-detail-item" style="background: #976A3466">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 60%; background: #976A34"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent">0%</div>
        </div>
        <div class="project-info-detail-item" style="background: #253e67">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 60%; background: #253e67"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent"></div>
        </div>
        <div class="project-info-detail-item" style="background: #0e456f">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 100%; background: #1b82a1"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent"></div>
        </div>
        <div class="project-info-detail-item" style="background: #0e456f">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 100%; background: #1b82a1"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent"></div>
        </div>
        
        
      </div>
    </div>
    <div class="project-info-item">
      <div class="project-name">基于abc的项目</div>
      <div class="project-info-detail">
        <div class="project-info-detail-item" style="background: #0e456f">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 60%; background: #1b82a1"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent">60%</div>
        </div>
        <div class="project-info-detail-item" style="background: #976A3466">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 60%; background: #976A34"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent">60%</div>
        </div>
        <div class="project-info-detail-item" style="background: #976A3466">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 60%; background: #976A34"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent">0%</div>
        </div>
        <div class="project-info-detail-item" style="background: #253e67">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 60%; background: #253e67"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent"></div>
        </div>
        <div class="project-info-detail-item" style="background: #0e456f">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 100%; background: #1b82a1"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent"></div>
        </div>
        <div class="project-info-detail-item" style="background: #0e456f">
          <div
            class="project-info-detail-item-percent-back"
            style="width: 100%; background: #1b82a1"
          ></div>
          <div class="project-info-detail-item-content">
            1233333333333333333333333333333333333
          </div>
          <div class="project-info-detail-item-percent"></div>
        </div>
        
        
      </div>
    </div> -->
    <!-- </div> -->
  </vue-seamless-scroll>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import { ajax } from "@/config/bi-request.js";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      autoScroll: false,
      projectData: [],
      classOption: {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: false, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      },
    };
  },
  mounted() {
    ajax
      .get("/getProjectInfo", {
        projectId: this.activeProjectId,
        groupId: this.activeGroupId,
      })
      .then((res) => {
        this.projectData = res;
        // this.projectData = [
        //   {
        //     name: "基于abc的萨克计划大红色的就哈可接受的和卡号的卡号的卡号看的骄傲和看进度项目",
        //     childer: [
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: false,
        //         isFinish: false,
        //         progressIsNormal: true,
        //         progress: "0%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: true,
        //         progressIsNormal: true,
        //         progress: "100%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: true,
        //         progress: "20%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: false,
        //         progress: "40%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: true,
        //         progress: "60%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: false,
        //         progress: "80%",
        //       },
        //     ],
        //   },
        //   {
        //     name: "基于abc的萨克计划大红色的就哈可接受的和卡号的卡号的卡号看的骄傲和看进度项目",
        //     childer: [
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: false,
        //         isFinish: false,
        //         progressIsNormal: true,
        //         progress: "0%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: true,
        //         progressIsNormal: true,
        //         progress: "100%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: true,
        //         progress: "20%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: false,
        //         progress: "40%",
        //       },
        //     ],
        //   },
        //   {
        //     name: "基于abc的萨克计划大红色的就哈可接受的和卡号的卡号的卡号看的骄傲和看进度项目",
        //     childer: [
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: false,
        //         isFinish: false,
        //         progressIsNormal: true,
        //         progress: "0%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: true,
        //         progressIsNormal: true,
        //         progress: "100%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: true,
        //         progress: "20%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: false,
        //         progress: "40%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: true,
        //         progress: "60%",
        //       },
        //     ],
        //   },
        //   {
        //     name: "基于abc的萨克计划大红色的就哈可接受的和卡号的卡号的卡号看的骄傲和看进度项目",
        //     childer: [
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: false,
        //         isFinish: false,
        //         progressIsNormal: true,
        //         progress: "0%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: true,
        //         progressIsNormal: true,
        //         progress: "100%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: true,
        //         progress: "20%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: false,
        //         progress: "40%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: true,
        //         progress: "60%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: false,
        //         progress: "80%",
        //       },
        //       {
        //         name: "子项目按时鉴定会卡仕达卡还是的卡号的夸奖哈电话卡就大A",
        //         isStart: true,
        //         isFinish: false,
        //         progressIsNormal: false,
        //         progress: "80%",
        //       },
        //     ],
        //   },
        // ];
      });
  },
  methods: {
    getBackColor(item) {
      if (item.isStart === false) {
        return "#1c2e4f";
      }
      if (item.isFinish === true) {
        return "#0e456f";
      }
      if (item.progressIsNormal === true) {
        return "#0e456f";
      }
      return "#976a3466";
    },
    getProgressColor(item) {
      if (item.progressIsNormal === true) {
        return "#1b82a1";
      }
      return "#976a34";
    },
  },
};
</script>

<style lang="less" scoped>
.scroll-content {
  animation: scroll 10s linear infinite;
}
.project-info-content {
  height: 100%;
  width: 100%;
  .project-info-item {
    padding: 0 8px;
    display: flex;
    // justify-content: center;
    align-items: center;
    .project-name {
      line-height: 1rem;
      // max-height: 2rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-size: 0.8rem;
      color: #ccc;
      width: 20%;
    }
    .project-info-detail {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      .project-info-detail-item {
        position: relative;
        margin: 0 2% 2% 0;
        width: 31%;
        height: 1.5rem;
        // background: #165a7f;
        overflow: hidden;
        display: flex;
        align-items: center;
        // padding: 4px 8px;
        box-sizing: border-box;
        color: #ccc;
        // opacity: 0.8;
        .project-info-detail-item-percent-back {
          position: absolute;
          height: 100%;
          z-index: 1;
        }
        .project-finish-icon {
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          background: #55c0e6;
          margin-left: 0.4rem;
          z-index: 5;
          display: flex;
          justify-content: center;
          align-items: end;
        }
        .project-info-detail-item-content {
          flex: 1;
          font-size: 0.8rem;
          z-index: 5;
          padding: 0 0.4em 0 0.4rem;
          word-break: keep-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          z-index: 5;
        }
        .project-info-detail-item-percent {
          font-size: 0.8rem;
          z-index: 5;
          padding-right: 0.5rem;
        }
        // .project-info-detail-item-icon {
        //   width: 0.8rem;
        //   height: 0.8rem;
        //   border-radius: 50%;
        //   background: #55bfe6;
        // }
        // .project-info-detail-item-text {
        //   padding-left: 6px;
        //   color: #ccc;
        //   flex: 1;
        //   overflow: hidden;
        //   text-overflow: ellipsis;
        // }
      }
    }
  }
}
</style>